import clsx from 'clsx';
import styles from './Content.module.scss';
import { type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  orientation?: 'vertical' | 'horizontal';
  spacing?: 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
  y?: 'start' | 'center' | 'end';
}

export function Content(props: Props) {
  const className = clsx(
    styles['root'],
    props.orientation &&
      styles[`orientation-${props.orientation ?? 'vertical'}`],
    props.spacing && styles[`spacing-${props.spacing ?? 'medium'}`],
    props.y && styles[`y-${props.y}`],
  );
  return <div className={className}>{props.children}</div>;
}
